import React from 'react';

export const ReviewsTab = ({ active, label, onClick }) => (
  <button
    onClick={onClick}
    className={`px-8 py-3 rounded-full font-semibold transition-all duration-300 ${
      active
        ? 'bg-brand-primary text-text-inverse'
        : 'bg-bg-card text-text-secondary border border-border-medium hover:border-brand-primary'
    }`}
  >
    {label}
  </button>
);
